export default (function ($target) {
    if ($target && !$target._dozAttach)
        $target._dozAttach = {};
});
